import { useState } from 'react';

const faqs = [
  {
    q: 'Do you provide phone support?',
    a: 'Yes. Call +1-844-499-3050 for live help, or use chat on familytreemakerrhelp.com if you prefer written step-by-step guidance.',
  },
  {
    q: 'Can you help with TreeVault sync problems?',
    a: 'Yes. We guide you through common TreeVault and device sync scenarios, including reconnecting after a new install.',
  },
  {
    q: 'Will upgrading erase my existing tree?',
    a: 'A proper upgrade keeps your data. We recommend a backup first, then we can walk you through verify steps after the update.',
  },
  {
    q: 'Do you support both Windows and Mac?',
    a: 'Yes. Tell us your operating system in chat and we will tailor the instructions for your setup.',
  },
  {
    q: 'Is this an official Family Tree Maker website?',
    a: 'We are an independent third-party support resource and are not affiliated with or endorsed by Family Tree Maker trademark owners.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="t7-section t7-section--white" id="faq">
      <div className="container max-w-3xl">
        <div className="t7-head t7-head--center">
          <p className="t7-kicker">FAQ</p>
          <h2 className="t7-title t7-title--center">Frequently asked questions</h2>
        </div>

        <div className="divide-y divide-[#c5d9cb] border-y border-[#c5d9cb]">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  className="w-full flex items-start justify-between gap-3 sm:gap-4 py-4 sm:py-5 text-left bg-transparent border-0 cursor-pointer touch-manipulation"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <span className="font-serif text-base sm:text-lg text-[#14201a] pr-2">
                    {item.q}
                  </span>
                  <span className="text-[#166534] font-bold text-xl leading-none shrink-0 mt-0.5">
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-4 sm:pb-5 pr-2 sm:pr-8 text-sm sm:text-base text-[#4d5c54] leading-relaxed m-0">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
